module.exports = __webpack_public_path__ + "static/media/sutd_cyber_sec_cert.5b2edd8f.pdf";